import { createSlice } from "@reduxjs/toolkit"
import { RootState } from "../../app/store"

export interface ConfigState {
  endpoint: string
  itemsPerPage: number
  language: string
}

const initialState: ConfigState = {
  endpoint: "",
  itemsPerPage: 4,
  language: "it",
}

export const configSlice = createSlice({
  name: "config",
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    setConfig: (state, action) => {
      state.endpoint = action.payload.endpoint
        ? action.payload.endpoint
        : state.endpoint
      state.itemsPerPage = action.payload.itemsPerPage
        ? action.payload.itemsPerPage
        : state.itemsPerPage
    },
  },
})

export const { setConfig } = configSlice.actions

export const selectEndpoint = (state: RootState) => state.config.endpoint
export const selectItemsPerPage = (state: RootState) =>
  state.config.itemsPerPage

export default configSlice.reducer
